// extracted by mini-css-extract-plugin
module.exports = {"label":"searchinput_label__msXQO","icon":"searchinput_icon__kLuFT","input":"searchinput_input__Gz4Pk","sm":"searchinput_sm__D1nT1","md":"searchinput_md__9KKbB"};